// src/api/axios.js
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Inject token if exists
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    const refreshToken = localStorage.getItem('refreshToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (refreshToken) {
      config.headers['refresh-token'] = `${refreshToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Global error handler
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       console.warn("Access token expired or invalid. Logging out.");
//       localStorage.clear();
//       //window.location.href = "/login";
//     }

//     return Promise.reject(error);
//   }
// );

export default axiosInstance;
